var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"absoluteTopRightButtonText",attrs:{"to":{ path: "/category", query: { type: "verified"}}}},[_c('span',{staticClass:"absoluteTopRightButtonText-text"},[_vm._v("看更多")]),_c('i',{staticClass:"icon-caret"})])
}
var staticRenderFns = []

export { render, staticRenderFns }